import './comment-list.scss'
import user from '../../../assets/images/user.svg';
import ImageGenerator from '../../image-generator/image-generator';
import React from 'react';

const CommentList = (comments) => {
	const commentList = comments && Array.isArray(comments.comments) ? comments.comments : [];
	const formatDate = (dateString) => {
		const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
		return new Date(dateString).toLocaleDateString('fa-IR', options);
	};

	return (
		<div className="comment-list">
			{commentList.length === 0 ? (
				<p className="no-comment">تاکنون نظری ثبت نشده است، شما اولین نفر باشید.</p>
			) : (
				commentList.map((comment, index) => (
					<div className="item" key={index}>
						<small>
							<ImageGenerator  src={user}  />
							{comment.user} - {formatDate(comment?.commentDate)}
						</small>
						<p>{comment.comment}</p>
					</div>
				))
			)}
		</div>
	);
}

export default CommentList;